export const painPoints = [
  { situation: 'Guardás muchas ideas', consequence: 'Pero después cuesta elegir por dónde empezar.' },
  { situation: 'Encontrás disfraces increíbles', consequence: 'Y necesitan materiales que no tenés a mano.' },
  { situation: 'Dejás todo para último momento', consequence: 'El armado termina siendo una corrida.' },
  { situation: 'Tu hijo no quiere dar miedo', consequence: 'Necesitás una alternativa que también le entusiasme.' },
  { situation: 'Querés que participe', consequence: 'Pero no sabés qué parte del armado compartir.' },
  { situation: 'Todo queda en capturas sueltas', consequence: 'Te falta una guía organizada para avanzar.' },
];
